import appConfig from 'app-config';
import AzarInduceRegisterModal from 'src/components/AzarOnly/InduceRegisterModal';
const InduceRegisterModal = (() => {
  if (appConfig.serviceCode === 'vividi') {
    return () => null;
  }
  return AzarInduceRegisterModal;
})();
export default InduceRegisterModal;